import React, { Component } from "react";
import "../../assets/web/assets/mobirise-icons2/mobirise2.css";
import "../../assets/web/assets/mobirise-icons/mobirise-icons.css";
import "../../assets/tether/tether.min.css";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/bootstrap/css/bootstrap-grid.min.css";
import "../../assets/bootstrap/css/bootstrap-reboot.min.css";
import "../../assets/dropdown/css/style.css";
import "../../assets/socicon/css/styles.css";
import "../../assets/theme/css/style.css";
import "../../assets/mobirise/css/mbr-additional.css";
import Header from "./navigation/Header";
import Footer from "./navigation/Footer";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  GetBusinessProfile,
  GetBusinessSystemAccount,
  GetSystemUser,
  GetBankInfos,
} from "../../store/actions/profileActions";
import Loading from "../widgets/Loading";

class BusinessDepositPage extends Component {
  state = {};

  componentDidMount() {
    document.title = "Loading...";
  }

  componentDidUpdate(prev, curr) {
    if (
      prev.firebase.profile.isLoaded === false &&
      this.props.firebase.profile.isLoaded === true &&
      prev.firebase.profile.isEmpty &&
      !this.props.firebase.profile.isLoaded
    ) {
      this.props.getBusiness();
    }
    if (
      this.props.profile !== null &&
      this.props.profile.profile !== null &&
      this.props.profile.profile !== undefined &&
      prev.profile.loading &&
      !this.props.profile.loading
    ) {
      this.props.getBusinessSystemAccount();

      this.props.getSystemUser();
      this.props.getBankInfos();
    } else if (
      !this.props.profile.regionloading &&
      !this.props.profile.banksloading &&
      !this.props.profile.suerloading &&
      document.title === "Loading..."
    ) {
      document.title = "Deposit";
    }
    // else if (this.props.profile.banks === []) {
    //   if (
    //     prev.firebase.profile.isLoaded === false &&
    //     this.props.firebase.profile.isLoaded === true
    //   ) {
    //     this.props.getBusiness();
    //     this.props.getBusinessSystemAccount();
    //     this.props.getSystemUser();
    //     this.props.getBankInfos();
    //   }
    // }
  }

  render() {
    if (this.props.auth.uid && !this.props.auth.isAnonymous) {
      if (
        !this.props.profile.regionloading &&
        !this.props.profile.banksloading &&
        !this.props.profile.suerloading &&
        this.props.profile.profile !== null
      ) {
        if (!this.props.profile.region.businessStatus) {
          return (
            <div>
              <Header />
              <section className="form5 cid-ssQVVQ31b6" id="buyairtimeform">
                <div className="container-fluid fullloading ">
                  <div className="mbr-section-head">
                    <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                      <strong>
                        All Deposit inquires have been blocked Temporarily.{" "}
                      </strong>
                    </h3>
                    {this.props.profile.systemuser && (
                      <div>
                        <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                          <br />
                          To discuss this issue please reach us through
                        </h3>
                        <h5 className="item-title mbr-fonts-style display-5 align-center">
                          <a
                            href={
                              this.props.profile.systemuser &&
                              "tel:" + this.props.profile.systemuser.phone
                            }
                            className="text-primary"
                          >
                            <strong>
                              {this.props.profile.systemuser &&
                                this.props.profile.systemuser.phone}
                            </strong>
                          </a>
                        </h5>
                      </div>
                    )}
                    <section
                      className="contacts2 cid-smJI7w9nls"
                      id="contacts2-j"
                    >
                      {/* <!----> */}

                      <div className="container">
                        <div className="mbr-section-head">
                          {this.props.profile.systemuser && (
                            <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                              Or you can get to us to us using our General Phone
                              Number or Email
                            </h3>
                          )}
                          {!this.props.profile.systemuser && (
                            <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                              <br />
                              To discuss this issue please reach us through
                            </h3>
                          )}
                        </div>
                        <div className="row justify-content-center mt-4">
                          <div className="card col-12 col-md-6">
                            <div className="card-wrapper">
                              <div className="image-wrapper">
                                <span className="mbr-iconfont mobi-mbri-phone mobi-mbri" />
                              </div>
                              <div className="text-wrapper">
                                <h6 className="card-title mbr-fonts-style mb-1 display-5">
                                  <strong>Phone</strong>
                                </h6>
                                <p className="mbr-text mbr-fonts-style display-7">
                                  <a
                                    href="tel:+251986558559"
                                    className="text-primary"
                                  >
                                    +251 986 55 85 59
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="card col-12 col-md-6">
                            <div className="card-wrapper">
                              <div className="image-wrapper">
                                <span className="mbr-iconfont mobi-mbri-letter mobi-mbri" />
                              </div>
                              <div className="text-wrapper">
                                <h6 className="card-title mbr-fonts-style mb-1 display-5">
                                  <strong>Email</strong>
                                </h6>
                                <p className="mbr-text mbr-fonts-style display-7">
                                  <a
                                    href="mailto:info@site.com"
                                    className="text-primary"
                                  >
                                    info@site.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </section>

              <Footer />
            </div>
          );
        } else if (this.props.profile.profile.status === 0) {
          return (
            <div>
              <Header />
              <section className="form5 cid-ssQVVQ31b6">
                <div className="container-fluid fullloading ">
                  <div className="mbr-section-head">
                    <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                      <strong>Your business is not active. </strong>
                    </h3>
                    {this.props.profile.systemuser && (
                      <div>
                        <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                          Your Business is currently not active.
                          <br />
                          To discuss this issue please reach us through
                        </h3>
                        <h5 className="item-title mbr-fonts-style display-5 align-center">
                          <a
                            href={
                              this.props.profile.systemuser &&
                              "tel:" + this.props.profile.systemuser.phone
                            }
                            className="text-primary"
                          >
                            <strong>
                              {this.props.profile.systemuser &&
                                this.props.profile.systemuser.phone}
                            </strong>
                          </a>
                        </h5>
                      </div>
                    )}
                    <section
                      className="contacts2 cid-smJI7w9nls"
                      id="contacts2-j"
                    >
                      {/* <!----> */}

                      <div className="container">
                        <div className="mbr-section-head">
                          {this.props.profile.systemuser && (
                            <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                              Or you can get to us to us using our General Phone
                              Number or Email
                            </h3>
                          )}
                          {!this.props.profile.systemuser && (
                            <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                              Your Business is currently not active.
                              <br />
                              To discuss this issue please reach us through
                            </h3>
                          )}
                        </div>
                        <div className="row justify-content-center mt-4">
                          <div className="card col-12 col-md-6">
                            <div className="card-wrapper">
                              <div className="image-wrapper">
                                <span className="mbr-iconfont mobi-mbri-phone mobi-mbri" />
                              </div>
                              <div className="text-wrapper">
                                <h6 className="card-title mbr-fonts-style mb-1 display-5">
                                  <strong>Phone</strong>
                                </h6>
                                <p className="mbr-text mbr-fonts-style display-7">
                                  <a
                                    href="tel:+251986558559"
                                    className="text-primary"
                                  >
                                    +251 986 55 85 59
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="card col-12 col-md-6">
                            <div className="card-wrapper">
                              <div className="image-wrapper">
                                <span className="mbr-iconfont mobi-mbri-letter mobi-mbri" />
                              </div>
                              <div className="text-wrapper">
                                <h6 className="card-title mbr-fonts-style mb-1 display-5">
                                  <strong>Email</strong>
                                </h6>
                                <p className="mbr-text mbr-fonts-style display-7">
                                  <a
                                    href="mailto:info@site.com"
                                    className="text-primary"
                                  >
                                    info@site.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </section>

              <Footer />
            </div>
          );
        } else if (
          this.props.profile.profile.system_user !== undefined &&
          this.props.profile.profile.system_user.length === 0
        ) {
          return (
            <div>
              <Header />
              <section className="form5 cid-ssQVVQ31b6">
                <div className="container-fluid fullloading ">
                  <div className="mbr-section-head">
                    <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                      <strong>
                        You currently don't have a personnel assigned to your
                        business.{" "}
                      </strong>
                    </h3>
                    {this.props.profile.systemuser && (
                      <div>
                        <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                          You can't deposit at the moment
                          <br />
                          To discuss this issue please reach us through
                        </h3>
                      </div>
                    )}
                    <section
                      className="contacts2 cid-smJI7w9nls"
                      id="contacts2-j"
                    >
                      {/* <!----> */}

                      <div className="container">
                        <div className="mbr-section-head">
                          <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-5">
                            Or you can get to us to us using our General Phone
                            Number or Email
                          </h3>
                        </div>
                        <div className="row justify-content-center mt-4">
                          <div className="card col-12 col-md-6">
                            <div className="card-wrapper">
                              <div className="image-wrapper">
                                <span className="mbr-iconfont mobi-mbri-phone mobi-mbri" />
                              </div>
                              <div className="text-wrapper">
                                <h6 className="card-title mbr-fonts-style mb-1 display-5">
                                  <strong>Phone</strong>
                                </h6>
                                <p className="mbr-text mbr-fonts-style display-7">
                                  <a
                                    href="tel:+251986558559"
                                    className="text-primary"
                                  >
                                    +251 986 55 85 59
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="card col-12 col-md-6">
                            <div className="card-wrapper">
                              <div className="image-wrapper">
                                <span className="mbr-iconfont mobi-mbri-letter mobi-mbri" />
                              </div>
                              <div className="text-wrapper">
                                <h6 className="card-title mbr-fonts-style mb-1 display-5">
                                  <strong>Email</strong>
                                </h6>
                                <p className="mbr-text mbr-fonts-style display-7">
                                  <a
                                    href="mailto:info@site.com"
                                    className="text-primary"
                                  >
                                    info@site.com
                                  </a>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </section>

              <Footer />
            </div>
          );
        } else {
          return (
            <div>
              <Header />
              <section className="features19 cid-sEbAIRqlGT" id="features20-2a">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-9">
                      <div className="card-wrapper pb-4">
                        <div className="card-box align-center">
                          <h4 className="card-title mbr-fonts-style mb-4 display-2">
                            <strong>Deposit to Your Negarit Account</strong>
                          </h4>
                          <a
                            className="btn btn-primary-outline display-4"
                            href="#video2-2b"
                          >
                            <u>Watch a video to learn how to deposit</u>
                          </a>
                          <p className="mbr-text mbr-fonts-style mb-4 display-7">
                            You need to deposit money to your Negarit account to
                            start buying advertisement spots for your company's
                            advertisement campaign.
                            <br />
                            <br />
                            <strong>
                              You can deposit to your Negarit Account by either
                              coming to our office or by following the steps
                              below
                            </strong>
                            <br />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-8">
                      <div className="item mbr-flex">
                        <div className="icon-box">
                          <span className="step-number mbr-fonts-style display-5">
                            1
                          </span>
                        </div>
                        <div className="text-box">
                          <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                            Deposit the money to one of these Accounts <br />
                          </h4>
                          {this.props.profile.banks &&
                            this.props.profile.banks.map((bank) => (
                              <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                                <strong>{bank.bankAccount}</strong>{" "}
                                {bank.bankAccountName} {bank.bankName}
                              </h4>
                            ))}
                        </div>
                      </div>
                      <div className="item mbr-flex">
                        <div className="icon-box">
                          <span className="step-number mbr-fonts-style display-5">
                            2
                          </span>
                        </div>
                        <div className="text-box">
                          <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                            <strong>
                              Contact Us Through{" "}
                              {this.props.profile.systemuser &&
                                this.props.profile.systemuser.phone}{" "}
                              After you Deposit the Money
                            </strong>
                          </h4>
                          <h5 className="icon-text mbr-black mbr-fonts-style display-4">
                            Call Us or Text your company name, the deposited
                            amount, and the your bank account name.
                            <br />
                            This have to be done in working hours.
                            <br />
                            <em>Example</em>
                            <br />
                            <em>
                              Company :{" "}
                              {this.props.profile.profile.business_name}
                            </em>
                            <br />
                            <em>
                              Identifier :{" "}
                              <strong>
                                {this.props.profile.profile.identifier}
                              </strong>
                            </em>
                            <br />
                            <em>
                              Sender's Full Name : Abebe Ketema Tesfaye (Replace
                              With Your Name)
                            </em>
                            <br />
                            <em>
                              Bank : Commercial Bank of Ethiopia (Replace With
                              Your Bank)
                            </em>
                            <br />
                            <em>
                              Deposited Amount : 5,000 ETB (Replace With Your
                              Amount)
                            </em>
                          </h5>
                        </div>
                      </div>
                      <div className="item mbr-flex last">
                        <div className="icon-box">
                          <span className="step-number mbr-fonts-style display-5">
                            3
                          </span>
                        </div>
                        <div className="text-box">
                          <h4 className="icon-title card-title mbr-black mbr-fonts-style display-7">
                            <strong>
                              Check Your Balance in Your Negarit Account
                            </strong>
                          </h4>
                          <h5 className="icon-text mbr-black mbr-fonts-style display-4">
                            Our Staff will give credit to your Negarit Account
                            Balance in a few minutes
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="video2 cid-sEbIYKdBkS" id="video2-2b">
                <div className="container">
                  <div className="mbr-section-head">
                    <h4 className="mbr-section-title mbr-fonts-style mb-0 display-2">
                      <strong>Watch How to Deposit</strong>
                    </h4>
                  </div>
                  <div className="row justify-content-center mt-4">
                    <div className="col-12 col-md-10 video-block">
                      <div className="video-wrapper">
                        <iframe
                          width="560"
                          height="560"
                          src="https://www.youtube.com/embed/xKSBJB5Nc7s"
                          title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <Footer />
            </div>
          );
        }
      } else {
        return (
          <div className="row justify-content-center fullloading">
            <div className="col-lg-8 form-group">
              <Loading />
            </div>
          </div>
        );
      }
    }
    return <Redirect to="/" />;
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    firebase: state.firebase,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBusiness: () => dispatch(GetBusinessProfile()),
    getBusinessSystemAccount: () => dispatch(GetBusinessSystemAccount()),
    getSystemUser: () => dispatch(GetSystemUser()),
    getBankInfos: () => dispatch(GetBankInfos()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessDepositPage);
